module.exports = __webpack_public_path__ + "img/logo.a52a714d.png";